import React, { useState } from "react";
import { Grid, Typography, Box, IconButton } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CircularProgress from "@mui/material/CircularProgress";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import { RiDeleteBin6Line } from "react-icons/ri";

import noImage from "../../../Assets/Images/no-photo.png"; // Adjust path as necessary
import ProgressBox from "./ProgressBox"; // Custom component
import DeleteMediaModal from "./DeleteMediaModal"; // Custom component

function RMLPopupAllMedia({
  storeData,
  handleCancelBulkUploadMedia,
  mediaList,
  handleErrorDoneButton,
  handleRetryFailMedia,
  setHoveredDeletedMediaUuid,
  hoveredDeletedMediaUuid,
  openDeleteMediaModal,
  setOpenDeleteMediaModal,
  handleClose,
  setDeleteMedia,
  deleteMedia,
  handleDeleteRMLMedia,
  selectedMedia,
  handleMediaClick,
  isSelected,
}) {
  // Renders media caption box
  const mediaCaptionBox = (media, mediaType) => (
    <div
      style={{
        left: "3px",
        bottom: mediaType === "video" ? "13px" : "4px",
        width: "80%",
        color: "#333",
        padding: "7px",
        position: "absolute",
        background: "#F4F4F4",
        borderRadius: "0px 0px 4px 4px",
        boxSizing: "border-box",
      }}
    >
      <Typography className="caption-text">{media?.description}</Typography>
    </div>
  );

  // Renders selected media indicator
  const selectedCircleIcon = () => (
    <IconButton
      sx={{
        position: "absolute",
        top: "10px",
        left: "133px",
        backgroundColor: "#FFFFFFCC",
        borderRadius: "50%",
        padding: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#4282E2",
      }}
    >
      <CheckCircleIcon sx={{ fontSize: "22px" }} />
    </IconButton>
  );

  return (
    <>
      <Box
        sx={{
          height: `${
            storeData?.isbulkUploading
              ? "calc(100vh - 180px)"
              : storeData?.failBulkUploadMediaLength > 0 && !storeData?.isbulkUploading
              ? "calc(100vh - 374px)"
              : storeData?.bulkUploadMediaLength > 0 &&
                storeData?.successfulBulkUploadMediaLength > 0 &&
                storeData?.bulkUploadMediaLength === storeData?.successfulBulkUploadMediaLength &&
                !storeData?.isbulkUploading
              ? "calc(100vh - 262px)"
              : "calc(100vh - 268px)"
          }`,
          overflowY: "auto",
          position: "relative",
          display: "block",
          scrollbarWidth: "thin",
          scrollbarColor: "#888888 #f5f5f5",
          "&::-webkit-scrollbar": {
            display: "block",
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f5f5f5",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "4px",
            "&:hover": {
              background: "#a8a8a8",
            },
          },
        }}
      >
        <Grid container spacing={3} sx={{ display: "flex", padding: "4px 0px 0px 14px" }}>
          {mediaList?.length !== 0 ? (
            mediaList?.map((media, index) => {
              let thumbnailUrl = `${storeData.inspectionData?.data?.bucket_url}${
                media?.thumbnail == null || media?.thumbnail_url == null ? media?.onlineUrl || media?.online_url : media?.thumbnail || media?.thumbnail_url
              }`;
              return media?.online === "offline" ? null : (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} sx={{ position: "relative", paddingTop: "10px !important" }} key={index}>
                  {media?.onlineUrl == null && media?.online_url == null ? (
                    <Box sx={{ position: "relative" }}>
                      <img
                        src={noImage}
                        className="rml_popup_media"
                        style={{
                          cursor: "pointer",
                          objectFit: "scale-down",
                          backgroundColor: "#FAFAFA",
                        }}
                        alt="no media"
                      />
                      {media?.is_media_uploading === false ? <WarningAmberIcon className="bulk_upload_circular_bar" /> : <CircularProgress className="bulk_upload_circular_bar" />}
                    </Box>
                  ) : media?.type?.startsWith("image/") || media?.media_type?.startsWith("image/") ? (
                    <>
                      <Box onMouseEnter={() => setHoveredDeletedMediaUuid(media?.id || media?.uuid)} onMouseLeave={() => setHoveredDeletedMediaUuid("")} sx={{ position: "relative" }}>
                        <img
                          className="rml_popup_media"
                          style={{
                            cursor: "pointer",
                            backgroundColor: "#FAFAFA",
                            width: "100%",
                            display: "block",
                            border: isSelected(index) ? "3px solid #4282e2" : "none",
                          }}
                          src={thumbnailUrl}
                          onClick={() => handleMediaClick(index)}
                          alt="report_media"
                          key={index}
                        />
                        {/* {media?.description && mediaCaptionBox(media, "image")} */}
                        {isSelected(index) && selectedCircleIcon()}
                        {hoveredDeletedMediaUuid == (media?.id || media?.uuid) && (
                          <RiDeleteBin6Line
                            className="rml_popup_delete_icon"
                            onClick={() => {
                              setOpenDeleteMediaModal(true);
                              setDeleteMedia(media);
                            }}
                          />
                        )}
                      </Box>
                      {media?.times_used > 0 && (
                        <Typography sx={{ fontStyle: "italic", fontWeight: "400 !important", fontSize: "10px !important" }}>
                          {" "}
                          Used {media?.times_used} other {media?.times_used == 1 ? "time" : "times"} in the report.{" "}
                        </Typography>
                      )}
                    </>
                  ) : media?.type?.startsWith("video/") || media?.media_type?.startsWith("video/") ? (
                    <>
                      <Box
                        className="report_media_thumb_wrapper_review report_video_thumb_container"
                        key={index}
                        onMouseEnter={() => setHoveredDeletedMediaUuid(media?.id || media?.uuid)}
                        onMouseLeave={() => setHoveredDeletedMediaUuid("")}
                        sx={{ position: "relative" }}
                      >
                        <Box sx={{ position: "relative" }}>
                          <img
                            className="rml_popup_media"
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#FAFAFA",
                              border: isSelected(index) ? "3px solid #4282e2" : "none",
                            }}
                            src={thumbnailUrl}
                            alt="video"
                            onClick={() => handleMediaClick(index)}
                          />
                          <PlayCircleIcon className="report_media_play_icon" />
                        </Box>
                        {/* {media?.description && mediaCaptionBox(media, "video")} */}
                        {isSelected(index) && selectedCircleIcon()}
                        {hoveredDeletedMediaUuid == (media?.id || media?.uuid) && (
                          <RiDeleteBin6Line
                            className="rml_popup_delete_icon"
                            onClick={() => {
                              setOpenDeleteMediaModal(true);
                              setDeleteMedia(media);
                            }}
                          />
                        )}
                      </Box>
                      {media?.times_used > 0 && (
                        <Typography sx={{ fontStyle: "italic", fontWeight: "400 !important", fontSize: "10px !important" }}> Used {media?.times_used} other times in the report. </Typography>
                      )}
                    </>
                  ) : (
                    <Box sx={{ position: "relative" }}>
                      <img
                        src={noImage}
                        className="rml_popup_media"
                        style={{
                          cursor: "pointer",
                          objectFit: "scale-down",
                          backgroundColor: "#FAFAFA",
                        }}
                        alt="no_media"
                      />
                      <WarningAmberIcon
                        className="bulk_upload_circular_bar"
                        sx={{
                          color: "#E02020",
                          width: "19.17px",
                          height: "16.67px",
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                        }}
                      />
                    </Box>
                  )}
                </Grid>
              );
            })
          ) : (
            <div className="no_media_found">
              <DoDisturbAltIcon sx={{ color: "#979797" }} />
              <Typography>No images or videos are in the report library.</Typography>
            </div>
          )}
        </Grid>
      </Box>

      {/* Progress Bar Section */}
      <ProgressBox storeData={storeData} handleCancelBulkUploadMedia={handleCancelBulkUploadMedia} handleRetryFailMedia={handleRetryFailMedia} handleErrorDoneButton={handleErrorDoneButton} />

      {/* Delete Media Modal */}
      <DeleteMediaModal
        open={openDeleteMediaModal}
        handleClose={handleClose}
        deleteMedia={deleteMedia}
        cancelBtnAction={handleClose}
        submitBtnAction={handleClose}
        handleDeleteRMLMedia={handleDeleteRMLMedia}
      />
    </>
  );
}

export default RMLPopupAllMedia;
